/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - พบผู้คนใหม่ๆ แชท เข้าสังคม",
      "หมายเลขโทรศัพท์ไม่ถูกต้อง",
      "Get the app",
      "ดำเนินการต่อด้วย Apple",
      "ดำเนินการต่อด้วย Facebook",
      "ดำเนินการต่อด้วย Google",
      "เข้าสู่ระบบ",
      "ลงทะเบียน",
      "เพื่อดำเนินการต่อ กรุณาใส่ตัวอักษรที่คุณเห็นลงในช่องข้อมูล",
      "ดำเนินการต่อ",
      "ใส่ตัวอักษร",
      "ด่านตรวจสอบความปลอดภัย",
      "โหลดใหม่",
      "สร้างรหัสผ่านใหม่ที่คุณจะจำได้อย่างง่ายดาย:",
      "อัปเดต",
      "ยืนยันรหัสผ่าน",
      "รหัสผ่านต้องมีอย่างน้อย {{num}} [[characters:num]]",
      "รหัสผ่าน",
      "สร้างรหัสผ่านใหม่",
      "Badoo - The Blog",
      "งาน",
      "แชท",
      "เมือง",
      "จัดการรักษาข้อมูล",
      "ลิขสิทธิ์ © 2006 – ปัจจุบัน Bumble สงวนลิขสิทธิ์",
      "Apple และโลโก้ Apple เป็นเครื่องหมายการค้าของ Apple Inc.{{__EOL__}}Google Play เป็นเครื่องหมายการค้าของ Google LLC",
      "ดาวน์โหลด",
      "Facebook",
      "ติดตามเรา",
      "ศูนย์ช่วยเหลือ",
      "Instagram",
      "ภาษา",
      "LinkedIn",
      "ภาพรวม",
      "Badoo เป็นส่วนหนึ่งของ Bumble Inc.",
      "นโยบายความเป็นส่วนตัว",
      "ศูนย์ความปลอดภัย",
      "Sitemap",
      "แถลงการณ์บัญญัติแรงงานทาสสมัยใหม่",
      "ข้อตกลงและเงื่อนไข",
      "Twitter",
      "ใส่อีเมลหรือหมายเลขโทรศัพท์มือถือของคุณ แล้วเราจะส่งคำแนะนำในการสร้างรหัสผ่านใหม่ให้คุณ",
      "รับรหัสผ่านใหม่",
      "ใส่อีเมลหรือหมายเลขโทรศัพท์ของคุณ",
      "ลืมรหัสผ่าน",
      "โมเดลใช้เพื่อจุดประสงค์ในการอธิบายเท่านั้น",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "ไม่จำเป็นต้องรอคนเหมาะสม{{__EOL__}}{{__EOL__}}เข้าไปแชทให้ลึกมากยิ่งขึ้น และตรงไปหาคนที่ดีต่อใจ ไปให้ถึงขั้นที่คุณจะได้ทำความรู้จักกันจริงๆ เลย",
      "พร้อมแชทตอนนี้เลยไหม?",
      "การลงทะเบียนแสดงว่าคุณยอมรับ <a class=\"link\" href=\"{{terms_url}}\">ข้อตกลงและเงื่อนไข</a> ของเรา เรียนรู้วิธีที่เราใช้ข้อมูลของคุณใน <a class=\"link\" href=\"{{privacy_url}}\">นโยบายความเป็นส่วนตัว</a>",
      "ช่วยให้คุณมีตัวตนที่แท้จริงมากขึ้น <br />สำหรับการออกเดทที่คุณรู้สึกดีด้วย",
      "นี่คือการออกเดทอย่างมั่นใจ",
      "หรือ",
      "มีบัญชีอยู่แล้ว?",
      "ลงทะเบียนด้วยอีเมลหรือหมายเลขโทรศัพท์ของคุณ",
      "ได้ในสิ่งที่คุณต้องการจากการออกเดท{{__EOL__}}ไม่จำเป็นต้องขอโทษ",
      "แค่อยากแชทเหรอ? ไม่เป็นไร{{__EOL__}}พร้อมจะจริงจังแล้ว? ถูกใจเลย{{__EOL__}}{{__EOL__}}และถ้าคุณเกิดเปลี่ยนใจ คุณก็ทำได้อย่างแน่นอน",
      "มาที่นี่เพื่อเดท",
      "พร้อมสานสัมพันธ์",
      "แชทได้",
      "พบผู้คนที่ต้องการในสิ่งเดียวกัน",
      "{{name}} {{age}}",
      "ความปลอดภัยของคุณเป็นสิ่งสำคัญอันดับหนึ่งของเรา",
      "ศูนย์ความปลอดภัยของเราเป็นศูนย์กลางความรู้ที่มีการสนับสนุนทั้งหมดที่คุณต้องการในการออกเดทด้วยความมั่นใจ",
      "ไปที่ศูนย์ความปลอดภัยของเรา",
      "ความปลอดภัยต้องมาอันดับหนึ่ง<br/> สอง และตลอดไป",
      "ตั้งแต่วินาทีแรก ฉันคิดว่ามันจะไปด้วยกันได้...",
      "ตอนแรก ฉันก็ไม่ได้มองหาอะไรจริงจังหรอก…",
      "คำแนะนำอย่างหนึ่งสำหรับทุกคนบนแอป Badoo คือเป็นตัวของตัวเอง...",
      "เรื่องราวความสำเร็จบน Badoo",
      "ดูเรื่องราวความสำเร็จเพิ่มเติม",
      "{{num}}__CUT__คะแนน",
      "Apple App Store",
      "เชื่อใจเราได้ เราได้รวบรวมผู้คนนับล้าน (และหลายล้าน และหลายล้าน) มารวมกันตั้งแต่ปี 2549 แล้ว",
      "{{num}} ล้าน+__CUT__ดาวน์โหลด",
      "{{num}} ล้าน+",
      "Google Play Store",
      "เรารู้ว่าเรากำลังทำอะไรอยู่",
      "เข้าสู่ระบบด้วยอีเมลหรือหมายเลขโทรศัพท์ของคุณ",
      "ใส่รหัสผ่านของคุณ",
      "ลืมรหัสผ่าน?",
      "ลงทะเบียน",
      "ไม่มีบัญชี?",
      "เข้าสู่ระบบ",
      "ลงทะเบียน"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "ตัวอักษร"
            ],
            "singular": [
                  "ตัวอักษร"
            ]
      },
      "day": {
            "plural": [
                  "วัน"
            ],
            "singular": [
                  "วัน"
            ]
      },
      "hour": {
            "plural": [
                  "ชั่วโมง"
            ],
            "singular": [
                  "ชั่วโมง"
            ]
      },
      "minute": {
            "plural": [
                  "นาที"
            ],
            "singular": [
                  "นาที"
            ]
      },
      "month": {
            "plural": [
                  "เดือน"
            ],
            "singular": [
                  "เดือน"
            ]
      },
      "second": {
            "plural": [
                  "วินาที"
            ],
            "singular": [
                  "วินาที"
            ]
      },
      "year": {
            "plural": [
                  "ปี"
            ],
            "singular": [
                  "ปี"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
